<template>
  <div v-if="visibleMarkers.length" :class="containerClass">
    <div
      v-if="!compact"
      class="font-secondary text-[12px] leading-[16px] text-gray-500 mb-1.5 flex items-center justify-between gap-x-3"
    >
      <span>Genetic markers</span>
    </div>
    <Markers :markers="visibleMarkers" :class="{ 'h-6': compact }" />
    <div v-if="!compact" class="w-full h-px my-4 bg-gray-200/50"></div>
  </div>
</template>

<script setup lang="ts">
import Markers, {
  type MarkerLike,
} from '@/features/copyright/components/Markers.vue'
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    markers?: ReadonlyArray<MarkerLike | null> | null
    compact?: boolean
  }>(),
  { markers: null, compact: false }
)

const visibleMarkers = computed(() => props.markers ?? [])
const containerClass = computed(() => (props.compact ? 'w-full' : 'mb-[25px]'))
</script>
